import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { RootState, AppDispatch } from "./store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Store and Persistor
export { store, persistor, type RootState, type AppDispatch } from "./store";

// Auth Slice
export {
  setCredentials,
  updateUser,
  clearCredentials,
  setLoading,
  useAuthState,
  useCurrentUser,
  useAuthToken,
} from "./slices/auth";
export { default as authReducer } from "./slices/auth";

// Settings Slice
export {
  toggleSidebar,
  setSidebarCollapsed,
  setTheme,
  setLanguage,
  resetSettings,
} from "./slices/settings";
export { default as settingsReducer } from "./slices/settings";

// UI Slice
export {
  PopupType,
  openPopup,
  closePopup,
  openCustomerForm,
  closeCustomerForm,
  openStaffForm,
  closeStaffForm,
  closeAllDrawers,
  setGlobalLoading,
  setCustomersLoading,
  setStaffLoading,
  setHeaderProps,
  clearHeaderProps,
  resetUI,
} from "./slices/uiSlice";
export { default as uiReducer } from "./slices/uiSlice";
export type {
  PopupState,
  DrawerState,
  HeaderState,
  UIState,
} from "./slices/uiSlice";
